import avatar1 from 'assets/images/avatar/avatar_1.webp';
import avatar2 from 'assets/images/avatar/avatar_2.webp';
import avatar3 from 'assets/images/avatar/avatar_3.webp';
import avatar4 from 'assets/images/avatar/avatar_4.webp';
import avatar5 from 'assets/images/avatar/avatar_5.webp';
import avatar6 from 'assets/images/avatar/avatar_6.webp';
import avatar7 from 'assets/images/avatar/avatar_7.webp';
import avatar8 from 'assets/images/avatar/avatar_8.webp';
import avatar9 from 'assets/images/avatar/avatar_9.webp';
import avatar10 from 'assets/images/avatar/avatar_10.webp';
import avatar11 from 'assets/images/avatar/avatar_11.webp';
import avatar12 from 'assets/images/avatar/avatar_12.webp';
import avatar13 from 'assets/images/avatar/avatar_13.webp';
import avatar14 from 'assets/images/avatar/avatar_14.webp';
import avatar15 from 'assets/images/avatar/avatar_15.webp';
import avatar16 from 'assets/images/avatar/avatar_16.webp';

export const users = [
  {
    id: 0,
    name: 'Yaga Masamichi',
    avatar: avatar1,
    email: 'yaga.masamichi@gmail.com',
    status: 'online',
  },
  { id: 1, name: 'Manami Suda', avatar: avatar2, email: 'manami.suda@gmail.com', status: 'online' },
  {
    id: 2,
    name: 'Okkotsu Yuta',
    avatar: avatar3,
    email: 'okkotsu.yuta@gmail.com',
    status: 'online',
  },
  {
    id: 3,
    name: 'Kugisaki Nobara',
    avatar: avatar4,
    email: 'kugisaki.nobara@gmail.com',
    status: 'online',
  },
  {
    id: 4,
    name: 'Nanami Kento',
    avatar: avatar5,
    email: 'nanami.kento@gmail.com',
    status: 'online',
  },
  {
    id: 5,
    name: 'Fushiguro  Megumi',
    avatar: avatar6,
    email: 'fushiguro.megumi@gmail.com',
    status: 'online',
  },
  { id: 6, name: 'Nitta Akari', avatar: avatar7, email: 'nitta.akari@gmail.com', status: 'online' },
  {
    id: 7,
    name: 'Inumaki  Toge',
    avatar: avatar8,
    email: 'inumaki.toge@gmail.com',
    status: 'online',
  },
  { id: 8, name: 'Todo Aoi', avatar: avatar9, email: 'todo.aoi@gmail.com', status: 'online' },
  {
    id: 9,
    name: 'Iori Utahime',
    avatar: avatar10,
    email: 'iori.utahime@gmail.com',
    status: 'online',
  },
  {
    id: 10,
    name: 'Tsukumo Yuki',
    avatar: avatar11,
    email: 'tsukumo.yuki@gmail.com',
    status: 'online',
  },
  {
    id: 11,
    name: 'Sakurai Haruto',
    avatar: avatar12,
    email: 'sakurai.haruto@gmail.com',
    status: 'online',
  },
  {
    id: 12,
    name: 'Gojo Satoru',
    avatar: avatar13,
    email: 'gojo.satoru@gmail.com',
    status: 'online',
  },
  { id: 13, name: 'Hanami', avatar: avatar14, email: 'hanami@gmail.com', status: 'online' },
  { id: 14, name: 'Zenin Maki', avatar: avatar15, email: 'zenin.maki@gmail.com', status: 'online' },
  {
    id: 15,
    name: 'Momo Nishimiya',
    avatar: avatar16,
    email: 'momo.nishimiya@gmail.com',
    status: 'online',
  },
];
